const MTU_EXCLUSION_AGENTS = [
  /Baiduspider/i, // Blocks the official Baidu search engine crawler
  /HeadlessChrome/i, // Blocks automated scraping and testing tools

  // Scripting Libraries
  /python-requests/i,
  /curl/i,
  /Go-http-client/i,
  /axios/i,

  // SEO & Marketing Crawlers
  /AhrefsSiteAudit/i,
  /AhrefsBot/i,
  /SemrushBot/i,
  /dotbot/i,
  /MJ12bot/i,
  /YandexBot/i,
  /Googlebot/i,

  // Monitoring & Health Checks
  /UptimeRobot/i,
  /Pingdom/i,

  // Social Media bots
  /meta-externalagent/i, // Blocks Meta's link preview crawler
  /facebookexternalhit/i, // Blocks older/related versions of the Facebook crawler
  /Twitterbot/i,
  /Pinterestbot/i,

  // Misc
  /Stripebot/i,
  /Bytespider/i,
  /DatadogSynthetics/i,
  /CloudWatchSynthetics/i,
];

// Bots rotating old Windows Chrome user agents (Chrome 103-133 surge from 2026-10-23) - Chrome auto-updates,
// so real users are almost never this far behind. Plain Chrome only, Edge/Opera/Yandex add their own tokens
const STALE_CHROME_MAJOR_VERSION = 134;

const isStaleWindowsChrome = agent => {
  if (!/Windows NT 10\.0/.test(agent) || /Edg\/|OPR\/|YaBrowser\//.test(agent)) return false;
  const chromeVersion = agent.match(/Chrome\/(\d+)\./);
  return !!chromeVersion && Number(chromeVersion[1]) < STALE_CHROME_MAJOR_VERSION;
};

const userAgent = typeof window !== 'undefined' ? window?.navigator?.userAgent ?? '' : '';
// Set by automation tools (Puppeteer, Playwright, Selenium) even when they fake the user agent
const isWebdriver = typeof window !== 'undefined' && window?.navigator?.webdriver === true;

// eslint-disable-next-line import/prefer-default-export
export const isExcludedBot =
  isWebdriver || isStaleWindowsChrome(userAgent) || MTU_EXCLUSION_AGENTS.some(regex => regex.test(userAgent));
